import { Badge } from '@/components/ui/badge';
import { Loader2 } from 'lucide-react';
import type { StepExecutionStatus } from '../types';

const statusConfig: Record<StepExecutionStatus, { label: string; variant: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline'; animate?: boolean }> = {
  pending: { label: 'En attente', variant: 'secondary' },
  extracting: { label: 'Extraction...', variant: 'default', animate: true },
  extract_failed: { label: 'Extraction échouée', variant: 'destructive' },
  mapping: { label: 'Mapping...', variant: 'default', animate: true },
  map_failed: { label: 'Mapping échoué', variant: 'destructive' },
  validating: { label: 'Validation...', variant: 'default', animate: true },
  validation_failed: { label: 'Validation échouée', variant: 'destructive' },
  migrating: { label: 'Migration...', variant: 'warning', animate: true },
  migrate_failed: { label: 'Migration échouée', variant: 'destructive' },
  completed: { label: 'Terminée', variant: 'success' },
  completed_with_errors: { label: 'Terminée avec erreurs', variant: 'warning' },
  skipped: { label: 'Ignorée', variant: 'outline' },
  bypassed: { label: 'Bypassée', variant: 'warning' },
};

interface StepStatusBadgeProps {
  status: StepExecutionStatus;
  className?: string;
}

export function StepStatusBadge({ status, className }: StepStatusBadgeProps) {
  const config = statusConfig[status] ?? { label: status, variant: 'secondary' as const };

  return (
    <Badge variant={config.variant} className={className}>
      {config.animate && <Loader2 className="h-3 w-3 animate-spin mr-1" />}
      {config.label}
    </Badge>
  );
}
